<div class="product-information-container" fxLayout="column" fxLayoutAlign="space-around stretch" fxLayoutGap="30px">
    <app-banner></app-banner>

    <div class="form-container">
        <h4 fxLayout="row wrap"  fxLayoutAlign="space-around center">{{'identify' | translate}}</h4>
        <form fxLayout="row wrap" #heroForm="ngForm" fxLayoutAlign="space-around center">
         
        <mat-form-field fxFlex="60" fxFlex.lt-md="100" appearance="fill">
          <mat-label>{{'serialNumber' | translate}}</mat-label>
          <input required [(ngModel)]="serialNumber" matInput name="serialOrImeiNumber">
        </mat-form-field>
          <div fxFill fxLayout="row wrap" fxLayoutAlign="center center">
            
            <mat-form-field fxFlex="60" fxFlex.lt-md="100" appearance="fill" ngClass.gt-sm="info-input">
              <mat-label>{{'imeiNumber' | translate}}</mat-label>
              <input required [(ngModel)]="imeiNumber" matInput name="serialOrImeiNumber">
            </mat-form-field>
            <button type="button" style="margin-top: -20px;" (click)="openInfoDialog()" mat-icon-button>
                      <mat-icon>info</mat-icon>

            </button>
          </div>
            
              
              <button mat-raised-button color="primary" [disabled]="!serialNumber && !imeiNumber" (click)="onSubmit()">{{'searchDevice' | translate}}</button>
        </form>
    </div>

</div>
